( function (Drupal, $) {
  /**
   * Set Landing / Article Header Background
   * @type {{attach: Drupal.behaviors.setLandingBackground.attach}}
   */
  Drupal.behaviors.setLandingBackground = {
    attach: (context) => {
      window.addEventListener('load', (event) => {
        const bodyClasses = document.body.classList;
        if (bodyClasses.contains('page-node-type-landing') || bodyClasses.contains('page-node-type-article')) {
          const header_group = document.getElementsByClassName('page-header-group');
          const background_image = bodyClasses.contains('page-node-type-landing')
            ? document.querySelectorAll('.hero__field-media img')
            : document.querySelectorAll('.article__field-image img');

          if (header_group && background_image[0]) {
            header_group[0].classList.add('page-header-group--bg-image');
            header_group[0].style.backgroundImage = 'url(' + background_image[0].currentSrc + ')';
          }
        }
      });
    }
  };

  /**
   * Set regular slider
   * @param i
   * @param slider
   */
  function slick_regular(i, slider) {
    const settings = {
      centerMode: false,
      centerPadding: 0,
      infinite: false,
      prevArrow: '<button type="button" class="slick-prev">⟨</button>',
      nextArrow: '<button type="button" class="slick-next">⟩</button>',
      variableWidth: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1184,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        },
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }
      ]
    };

    if($(slider).hasClass('ccc-no-desktop-slider')) {
      $(window).on('load resize', function () {
        if ($(window).width() > 1184) {
          if ($(slider).hasClass('slick-initialized')) {
            $(slider).slick('unslick');
          }
          return;
        }
        if (!$(slider).hasClass('slick-initialized')) {
          return $(slider).slick(settings);
        }
      });
    }
    $(slider).slick(settings);
  }

  /**
   * Set slider only on mobile breakpoint
   * @param i
   * @param slider
   */
  function slick_mobile(i, slider) {
    $(window).on('load resize', function () {
      if ($(window).width() > 767) {
        if ($(slider).hasClass('slick-initialized')) {
          $(slider).slick('unslick');
        }
        return;
      }
      if (!$(slider).hasClass('slick-initialized')) {
        return $(slider).slick({
          slidesToShow: 1,
          centerMode: false,
          centerPadding: 0,
          infinite: false,
          slidesToScroll: 1,
          variableWidth: true,
          arrows: false,
          dots: true
        });
      }
    });
  }

  /**
   * Set slider only on mobile breakpoint
   * @param i
   * @param slider
   */
  function slick_tile(i, slider) {
    const all_link = $('.tile-wall__link-container');
    const all_link_clone = $('.tile-wall__link-container').clone();

    $(window).on('load resize', function () {
      if ($(window).width() > 975) {
        if ($(slider).hasClass('slick-initialized')) {
          $(slider).slick('unslick');
          $(all_link_clone).appendTo('.tile-wall__group');
        }
        return
      }
      if (!$(slider).hasClass('slick-initialized')) {
        $(all_link).remove();

        $(slider).on('init', function (e, slick) {
          $(all_link_clone).appendTo('.tile-wall__container');
        });

        return $(slider).slick({
          slidesToShow: 1,
          centerMode: false,
          centerPadding: 0,
          infinite: false,
          slidesToScroll: 1,
          variableWidth: true,
          arrows: false,
          dots: true
        });
      }
    });
  }

  /**
   * Initialize Slider
   * @type {{attach: Drupal.behaviors.cccSlideViewer.attach}}
   */
  Drupal.behaviors.cccSlideViewer = {
    attach(context) {
      const $regular_slider = $(context).find('.ccc-slider');
      const $mobile_slider = $(context).find('.ccc-mobile-slider');
      const $tile_slider = $(context).find('.ccc-tile-slider');

      if ($regular_slider.length) {
        $.each($regular_slider, slick_regular);
      }

      if ($mobile_slider.length) {
        $.each($mobile_slider, slick_mobile);
      }

      if ($tile_slider.length) {
        $.each($tile_slider, slick_tile);
      }
    },
  };

  /**
   * Search form behavior
   * @type {{attach: Drupal.behaviors.cccSearchForm.attach}}
   */
  Drupal.behaviors.cccSearchForm = {
    attach(context) {
      const $search_component = $(context).find('.cccis-global-search-form');
      const $search_input = $search_component.find('.form-search');

      $search_component.hover(
        function () {
          $search_component.addClass('active');
        },
        function () {
          $search_component.removeClass('active');
        }
      );
    },
  };

  /**
   * Mobile Menu behavior
   * @type {{attach: Drupal.behaviors.cccMobileMenu.attach}}
   */
  Drupal.behaviors.cccMobileMenu = {
    attach(context) {
      const $navbar = $(context).find('.navbar-main');
      const $toggler = $(context).find('.navbar-toggler');

      $(window).on('load resize', function () {
        if ($(window).width() < 1200) {
          $toggler.on('click', function () {
            if ($toggler.hasClass('collapsed')) {
              $navbar.addClass('mobile-nav');
            } else {
              $navbar.removeClass('mobile-nav');
            }
          });
        } else {
          $navbar.removeClass('mobile-nav');
        }
      });
    },
  };

  /**
   * API page dynamic components
   * @type {{attach: Drupal.behaviors.cccMobileMenu.attach}}
   */
  Drupal.behaviors.cccMobileAPIPage = {
    attach(context) {
      window.addEventListener('load', (event) => {
        const bodyClasses = document.body.classList;
        if ( bodyClasses.contains('page-node-type-apidoc') ) {

          // Managing navigation pane collapse
          const $pageNavigationPane = $('.page__api-doc-navigation');
          $('.api-doc-table-btn').on('click', () => {
            $pageNavigationPane.addClass('active');
          });

          $('.api-doc-close-sidebar').on('click', () => {
            $pageNavigationPane.removeClass('active');
          });

          // Sync navigation dropdown and tabs
          const $navDropdown = $('.api-doc-nav-dropdown');
          const $navTabs = $('.apidoc-tabs');

          $navDropdown.find('.dropdown-item').on('click', function () {
            syncDropdown($(this).text());
            $navTabs.find('.active').removeClass('active');
            $navTabs.find('.nav-link[href="' + $(this).attr('href') + '"]').addClass('active');
          });

          $navTabs.find('.nav-link').on('click', function () {
            syncDropdown($(this).text());
            $navDropdown.find('.dropdown-item[href="' + $(this).attr('href') + '"]').addClass('active');
          });

          let syncDropdown = elemText => {
            $navDropdown.find('.active').removeClass('active');
            $navDropdown.find('.dropdown-toggle').text(elemText);
          }
        }
      });
    },
  };
})(Drupal, jQuery)
